import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CARDS_ROUTE_PATHS } from '../config';

export const AFFILIATES_ROUTES: TApplicationRoute[] = [
  {
    id: 'cards-affiliates',
    path: CARDS_ROUTE_PATHS.affiliates,
    component: lazy(() => import('./pages/affiliates-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['affiliates'] },
    menu: {
      title: 'Affiliates',
    },
  },
];
